<template>
  <template v-if="sidebarComponents.length === 0">
    <div id="project-standard" class="project-section pt-60 pb-120 tw-overflow-hidden">
    <div class="container">
      <h2 class="tw-mb-8 tw-self-center tw-text-center">{{ vars.titleText }}</h2>
      <div class="row">
        <div class="project-slider-2 owl-carousel">
          <a
            v-for="(property, index) in mixedProperties"
            :key="property.id || index"
            class="single-project-wrapper n-link"
          >
            <theme9-properties-property-list-item
              :property="property"
              :is-match-information-hidden="true"
              :pre-market-property-feature="true"
              :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
              :is-vertical="true"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
  </template>
  <template v-else-if="sidebarComponents.length > 0">
    <div id="project-standard" class="project-section pt-60 pb-120 tw-overflow-hidden">
    <div class="container">
      <h2 class="tw-mb-8 tw-self-center tw-text-center">{{ vars.titleText }}</h2>
      <div class="row">
        <div class="project-slider-2 owl-carousel">
          <a
            v-for="(property, index) in mixedProperties"
            :key="property.id || index"
            class="single-project-wrapper n-link"
          >
            <theme9-properties-property-list-item
              :property="property"
              :is-match-information-hidden="true"
              :pre-market-property-feature="true"
              :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
              :is-vertical="true"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
  </template>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import { PropertiesMixin } from '~/units/properties/mixins/properties.mixin';
import { mapState } from 'pinia';
import { useWebsiteStore } from '~/units/website/store';
import { Pagination as SwiperPagination } from 'swiper/modules';

interface ComponentData {
  swiper: any | null;
  canPaginateBack: boolean;
  selectedProperty: any | null;
  isVisible: boolean;
  canPaginateNext: boolean;
  variants: {
    v1: string;
    v2: string;
  };
  swiperModules: any[];
}

export default defineNuxtComponent({
  name: 'Theme9LatestProperties',

  mixins: [ComponentMixin, PropertiesMixin],

  async setup(props: any) {
    try {
      await fetchPropertiesManager(props.component, null);
    } catch (error) {
      console.error('Error fetching properties:', error);
    }
  },

  data(): ComponentData {
    return {
      swiper: null,
      canPaginateBack: true,
      selectedProperty: null,
      isVisible: false,
      canPaginateNext: true,
      variants: {
        v1: 'v1',
        v2: 'v2',
      },
      swiperModules: [SwiperPagination],
    };
  },

  computed: {
    ...mapState(useWebsiteStore, ['sidebarComponents']),
    loopedProperties() {
      try {
        return this.properties ? [...this.properties, ...this.properties] : [];
      } catch (error) {
        console.error('Error in loopedProperties computed:', error);
        return [];
      }
    },

    mixedProperties() {
      try {
        if (!this.properties || this.properties.length === 0) return [];

        const rentProperties = this.properties.filter((property) => property.is_rent);
        const saleProperties = this.properties.filter((property) => !property.is_rent);

        const result = [];
        const maxLength = Math.max(rentProperties.length, saleProperties.length);

        for (let i = 0; i < maxLength; i++) {
          if (i < saleProperties.length) result.push(saleProperties[i]);
          if (i < rentProperties.length) result.push(rentProperties[i]);
        }

        return result;
      } catch (error) {
        console.error('Error in mixedProperties computed:', error);
        return [];
      }
    },

    buttons() {
      return this.groupedVariables.buttons;
    },

    /**
     * Determines how many property cards should be rendered per slide for ≥768px viewports.
     * Requirement: if there are sidebar components we must show exactly **one** card per slide;
     * otherwise keep existing behaviour (two cards).
     */
    carouselItems(): number {
      return this.sidebarComponents && this.sidebarComponents.length > 0 ? 1 : 2;
    },
  },

  mounted() {
    this.$nextTick(() => {
      if (process.client) {
        this.initCarousel();
      }
    });
  },

  watch: {
    mixedProperties(newVal) {
      if (newVal.length > 0) {
        this.$nextTick(() => {
          this.initCarousel();
        });
      }
    },
  },

  methods: {
    initCarousel() {
      if (typeof window !== 'undefined' && window.$ && window.$.fn.owlCarousel) {
        const $ = window.$;
        $('.project-slider-2').owlCarousel('destroy'); // Fix selector
        $('.project-slider-2').owlCarousel({
          loop: true,
          margin: 30,
          nav: true,
          dots: false,
          navText: ["<i class='las la-arrow-left'></i>", "<i class='las la-arrow-right'></i>"],
          responsive: {
            0: {
              items: 1,
            },
            768: {
              items: this.carouselItems,
            },
          },
        });
      } else {
        console.warn('jQuery or Owl Carousel not loaded');
      }
    },
  },
});
</script>
